import { inject } from 'vue';
import { PageableResponse, Article, SingleRecordResponse } from '~/types';
import { AxiosInstance } from 'axios';

export const useArticlesApi = () => {
  const axios: AxiosInstance | undefined = inject('axios');

  const search = async (params: Article.RequestParameters = {}): Promise<PageableResponse<Article.Model>> => {
    if (axios === undefined) {
      return Promise.reject('Axios not injected');
    }

    const { data } = await axios.get('/api/articles/', {
      params,
    });

    return data;
  };

  const view = async (id: number, params?: Article.RequestParameters): Promise<SingleRecordResponse<Article.Model>> => {
    if (axios === undefined) {
      return Promise.reject('Axios not injected');
    }
    const { data } = await axios.get(`/api/articles/${id}`, { params });

    return data;
  };

  return { search, view };
};
